import React from "react";
import Users from "../../Components/Users/users";


const UsersPage = ({user}) => {
    return (<div>
        <Users user={user} />
    </div>)
}

export default UsersPage